import { z } from 'zod';
import { InspectionTranscriptIndexCreatedSchema } from '../base/transcriptIndexCreated.js';
import { InspectionsServiceEventBaseSchema, inspectionsServiceEventType } from './service.js';
const transcriptEventType = (eventName) => inspectionsServiceEventType('transcript', eventName);
export const InspectionTranscriptIndexCreatedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: transcriptEventType('indexCreated'),
    schemaVersion: z.literal(1),
    index: InspectionTranscriptIndexCreatedSchema,
}));
